import * as React from "react";
import { useGetCclParticipantsByEmailQuery } from "../../../../services/cclTokenedEnterpriseParticipantApi";
import UserRegistrationDataGrid from "./userRegistrationDataGrid";
interface UserSessionsPanelProps {
    emailAddress: string;
}

const UserSessionsPanel: React.FC<UserSessionsPanelProps> = (props) => {
    const { data, isLoading, isSuccess } = useGetCclParticipantsByEmailQuery(
        props.emailAddress.trim(),
        { skip: !props.emailAddress }
    );

    if (isSuccess || isLoading) {
        return <UserRegistrationDataGrid registrations={data ?? []} loading={isLoading} />;
    }
    return <span>Unknown Error Loading Session</span>;
};

export default UserSessionsPanel;
